import React, { ReactElement } from 'react';
import classnames from 'classnames';

interface Props {
  width?: number;
  height?: number;
  location?: string;
  theme?: 'light';
}

const BluebeamLogoSmall = (props: Props): ReactElement => {
  const { theme, width, location } = props;

  return (
    <div
      className={classnames('', {
        'flex row h100 items-center justify-center': location === 'sideNav',
        'flex column justify-center items-center px2 wrem-9 h100':
          location === 'projectPage',
        'flex column justify-center items-center wrem-9 h100':
          location === 'mapPage',
      })}
    >
      {theme === 'light' ? (
        <svg
          width={`${width}px`}
          viewBox="0 0 27 27"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.99118 17.988V8.99118H17.9824V17.9824H8.99118V17.988ZM8.99118 0V4.49559H22.478V22.478H4.49559V0H0V26.9792H26.9792V0H8.99118Z"
            fill="#0074CC"
          />
        </svg>
      ) : (
        <svg
          width={`${width}px`}
          viewBox="0 0 27 27"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.99118 17.988V8.99118H17.9824V17.9824H8.99118V17.988ZM8.99118 0V4.49559H22.478V22.478H4.49559V0H0V26.9792H26.9792V0H8.99118Z"
            fill="#0074CC"
          />
        </svg>
      )}
    </div>
  );
};

export default BluebeamLogoSmall;
